import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { useState } from 'react';
export default function Select({ options, onChange, value, placeholder }) {
  const [selected, setSelected] = useState(value || '');
  const selectedValue = options.find((item) => item.value === selected);
  return (
    <div className="w-full">
      <Listbox
        value={selected}
        onChange={(val) => {
          setSelected(val);
          onChange(val);
        }}
      >
        <ListboxButton
          className={clsx(
            'relative flex justify-between text-black dark:text-shoorah-darkBg items-center w-full rounded-lg py-1.5 px-3 text-left text-sm/6 max-w-full truncate'
          )}
        >
          {selectedValue?.label || placeholder || 'Select'}
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" className='text-[#5A5A5A] dark:text-shoorah-darkBg' xmlns="http://www.w3.org/2000/svg">
            <path d="M4.92673 6.5194L0.520612 1.67267C-0.0633641 1.0303 0.392408 0 1.26055 0H10.0728C10.9409 0 11.3967 1.0303 10.8127 1.67267L6.40661 6.5194C6.00985 6.95584 5.32349 6.95583 4.92673 6.5194Z" fill="currentColor"/>
          </svg>
        </ListboxButton>
        <ListboxOptions
          anchor="bottom"
          transition
          className={clsx(
            'w-auto shadow-md border rounded-xl bg-white dark:bg-shoorah-darkBgColor border-none p-1 focus:outline-none',
            'transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0'
          )}
        >
          {options.map((option) => (
            <ListboxOption
              key={option.value}
              value={option.value}
              className="group flex cursor-default items-center gap-2 rounded-lg py-1.5 px-3 select-none data-[focus]:bg-shoorah-secondary/15 text-shoorah-secondary"
            >
              <div className="text-sm/6 text-black dark:text-shoorah-darkBg">{option.label}</div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
    </div>
  );
}
